module.exports = __webpack_public_path__ + "img/about-company-03.d99d1fab.jpeg";